import axios from 'axios';

export default function initInterceptors() {
  axios.interceptors.response.use(
    (config) => config,
    (err) => {
      console.warn(err);
      return Promise.reject(err);
    }
  );
}
